import * as React from 'react'
import styles from './style.module.css';
import Button from '../../../design-system/lib/Button';
import { ADDRESS_BOOK, AUTO_DISPATCH, CLOSE, CLOSE_DARK, CUSTOMER_TYPE, database, double_top, DRAG, DROPOFF, HISTORY, INFO_CIRCLE, LOCATION, map, MAP, newsearch, PERSON, PICKUP, pickup_new, trash } from '../../../assets';
import DropDown from '../../../design-system/lib/DropDown';
import Modal from '../../../design-system/lib/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { SetCanSaveTravel, SetPriceNewOrder, Set_Auto_ActiveVehicleTypeـPickupDeliveryType_Dropoff, Set_Auto_ActiveVehicleTypeـPickupDeliveryType_Pickup, Set_DropOff_Inputs, Set_Pickup_address, Set_SearchAutoCompleteLoading, Set_latlng, SetopenAddressBookInNewOrder } from '../../../Redux/actions/actionNames';
import { getCenterMap, setCenterMap } from '../../../helper/module';
import { PlaceIdDetailsAction, SearchAutoCompleteAction, SearchAutoCompleteAction_local_address } from '../../../Redux/actions/actions';
import { useTranslation } from 'react-i18next';
import Input from '../../../design-system/lib/Input';
import IconProvider from '../../../design-system/lib/IconProvider';
import Typography from '../../../design-system/lib/Typography';
import CustomerListItem from '../customer/components/list-Item';
import SearchList from '../../../design-system/lib/SearchList';
import { v4 as uuidv4 } from 'uuid';
import _, { isEmpty } from "lodash";
import RecentAddressItem from './components/recentAddressItem';
import AddressItem from './components/addressItem';
import DeliveryInfoNewOrder from './components/info';
import clsx from 'clsx';
import removeDropOff from "../../../assets/removeDropOff.svg";
import { UseCRUDDropoffs } from '../../../hooks/useCRUD_Dropoffs';
import Schedule from '../Schedule/Schedule';
import service_point from '../../../assets/service_point.svg';
import service_point_color from '../../../assets/service_point_color.svg';
import danger from '../../../assets/danger.svg';
import location_gray from '../../../assets/location_gray.svg';

import ServicePoint_addressItem from './components/servicePoint_addressItem';
import { ServicesApi } from '../../../service/API/service';

function DeliveryNewOrder({ handleCollapse, dropOffsCount, isDraggingOver, index, last, first, addDropOff, id, removeDrop, orderTypeActive, dropOffCount, ...props }) {
  let { items, sEtItems } = UseCRUDDropoffs()

  console.log("DeliveryNewOrder ", dropOffsCount, isDraggingOver, index, last, first, id, orderTypeActive, dropOffCount, props)

  const [isLocalAddressActive, setIsLocalAddressActive] = React.useState(global.config.dispatcherSettings.isLocalAddressActive);
  const [localSearchIsActive, setLocalSearchIsActive] = React.useState(global.config.dispatcherSettings.isLocalAddressActive ? true : false);
  // const [id, setid] = React.useState("dropoff");
  const [ordered, setOrdered] = React.useState(true);
  const [showpoper, setShowpoper] = React.useState(false);
  const [showpoperSaved, setShowpoperSaved] = React.useState(false);
  const [getFavAddressLoading, setGetFavAddressLoading] = React.useState(false);
  const [searchAddrees, setSearchAddrees] = React.useState("");
  const [sessionToken, setSessionToken] = React.useState(null);
  const BusinessId = useSelector((state) => state.NewOrder.newOrder.customer.BusinessId)

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const customerId = useSelector((state) => state.NewOrder.newOrder.customer.id)
  const mapRef = useSelector((state) => state.Map.mapRef)
  const center = useSelector((state) => state.Map.center)
  const adresss_loc = props.adresss_loc;
  const emailg = props.email
  const senderFullName = props.recieverFullName
  const senderPhoneNumber = props.recieverPhoneNumber
  const activePickupDropOff = useSelector((state) => state.NewOrder.newOrder.activePickupDropOff)
  const suggestListPickUpDropOffLoading = useSelector((state) => state.NewOrder.newOrder.suggestListPickUpDropOffLoading)
  const suggestPickUpDropOffListData = useSelector((state) => state.NewOrder.newOrder.suggestPickUpDropOffListData)
  const activeVehicleType = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType)
  const recentAddress = useSelector((state) => state.NewOrder.newOrder.customer.recentAddreess)
  const ActivescheduleSetting = useSelector((state) => state.NewOrder.newOrder.deliveryMethod ? (state.NewOrder.newOrder.deliveryMethod?.scheduleSetting?.isActive && state.NewOrder.newOrder.deliveryMethod?.scheduleSetting?.hasDropoffScheduling) : false)

  const auto_activeVehicleType = props.driver.auto_driver.auto_activeVehicleType
  const manual_activeVehicleType = props.driver.manual_driver.manual_activeVehicleType
  const driveroptions = props.driver.options

  const delayedQuery = React.useCallback(_.debounce((...pr) => HandleChange(...pr), 500), []);
  const delayedQuerySP = React.useCallback(_.debounce((...pr) => HandleChangeSP(...pr), 500), []);

  const auto_suggestListData = useSelector((state) => state.NewOrder.newOrder.driver.auto_driver.auto_suggestListData)
  const openAddressBook = useSelector((state) => state.Addressbook.openAddressBookInNewOrder)
  const addressBookSource = useSelector((state) => state.Addressbook.openAddressBookInNewOrder
    ? state.Addressbook.sourceOfAddressBookInNewOrder
      ? state.Addressbook.sourceOfAddressBookInNewOrder.type == "dropoff" &&
      id == state.Addressbook.sourceOfAddressBookInNewOrder.id
      : false
    : false)

  const delivery_manual_id = useSelector((state) => state.NewOrder.newOrder.dropOffs.firstDropOff.driver.manual_driver.manual_id)
  const DeliveryServicePoint = props.ServicePoint
  const deliveryLocationType = useSelector((state) => state.NewOrder.newOrder.deliveryMethod?.dropoffLocationType)
  const deliveryMethod = useSelector((state) => state.NewOrder.newOrder.deliveryMethod)

  const [servicepoints, setServicepoints] = React.useState([]);
  const [servicepointsIsLoading, setServicepointsIsLoading] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(false);


  const pickupRequiredCheck = React.useCallback(() => {
    if (activeVehicleType) {
      let name = false, email = false, phone = false;

      if (activeVehicleType.setting.isDropoffAddressNameRequired) {
        if (senderFullName && String(senderFullName).trim().length > 0) {
          name = true
        } else {
          name = false
        }
      } else {
        name = true
      }

      if (activeVehicleType.setting.isDropoffAddressPhoneRequired) {
        if (senderPhoneNumber && String(senderPhoneNumber).trim().length > 0) {
          phone = true
        } else {
          phone = false
        }
      } else {
        phone = true
      }


      if (activeVehicleType.setting.isDropoffAddressEmailRequired) {
        if (emailg && String(emailg).length > 0 && emailValidate(String(emailg))) {
          email = true
        } else {
          email = false
        }
      } else {
        email = true
      }



      return (name && phone && email);

    } else {
      return false
    }

  }, [activeVehicleType, emailg, senderPhoneNumber, senderFullName]);


  
        const showRequirdalert = React.useCallback(() => {
  
        let xx = !pickupRequiredCheck() ;
        let yy = false ;
  
 
      try {
  
           activeVehicleType?.orderCustomFieldDefinitions?.filter((item) => { return (item.stage == "dropoff" && item.isRequired) }).forEach((item)=>{
 
            if(!props.customField[item.key]){ 
              yy = true
            }
          })

                    console.log("sadasd" , xx  ,  yy)

 
          return (xx || yy)
      } catch (error) {
        return false
      }
    
   
  
    }, [ props.customField , activeVehicleType ,pickupRequiredCheck ]);


  const HandleChangeSP = React.useCallback((value) => {

    (async () => {
      setServicepointsIsLoading(true)
      const Services = new ServicesApi();
      const ServicePoints = await Services.ServicePoints({
        deliveryMethodId: deliveryMethod?.id,
        locationType: "dropoff",
        search: value
      })
      console.log("ServicePoints5 ", ServicePoints)
      setServicepoints(ServicePoints)
      setServicepointsIsLoading(false)

    })();

  }, [deliveryMethod]);



  const HandleChange = React.useCallback((value, localSearchIsActive, sessionToken) => {

    let centerr = getCenterMap(mapRef, center)
    String(value).length > 0 && dispatch(Set_SearchAutoCompleteLoading(true));

    console.log("localSearchIsActive ", localSearchIsActive)
    if (!localSearchIsActive) {
      String(value).length > 0 && dispatch(
        SearchAutoCompleteAction(dispatch, {
          query: value,
          latitude: centerr.lat,
          longitude: centerr.lng,
          sessionToken: sessionToken
        })
      );
    } else {
      String(value).length > 0 && dispatch(
        SearchAutoCompleteAction_local_address(dispatch, {
          query: value
        })
      );
    }


  }, [localSearchIsActive, sessionToken, mapRef, center]);


  const handleSearchSPInput = React.useCallback((e, name) => {
    if (e?.target?.ignore) {
      return null
    }
    if (name === "address" || e?.target.id === "address") {
      if (e && e?.target.value != "") {
        e?.target?.value.length > 2 && delayedQuerySP(e?.target.value)

        if (e?.target?.value.length == 0 && props.address?.length > 0) {
          delayedQuerySP(e?.target.value)
        }
      }

      if (e?.target?.value.length == 0) {
        delayedQuerySP("")
      }
    }

    if (e) {
      dispatch(
        Set_DropOff_Inputs({
          name: name || e?.target.id,
          value: e?.target.value,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
    }

  }, [sessionToken, localSearchIsActive, id, first]);


  const handlePickUpInputs = React.useCallback((e, name) => {

    if (name === "address" || e?.target.id === "address") {

      setSessionToken(sessionToken ? sessionToken : uuidv4())

      if (e && e?.target.value != "") {
        e?.target?.value.length > 2 && delayedQuery(e?.target.value, localSearchIsActive, sessionToken)
      }
    }

    if (e) {
      dispatch(
        Set_DropOff_Inputs({
          name: name || e?.target.id,
          value: e?.target.value,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
    }

  }, [sessionToken, localSearchIsActive, id, first]);

  const handleChangeLocalSearch = React.useCallback((value) => {

    setLocalSearchIsActive(value == t("Map") ? false : true)
    // setTimeout(() => {
    //   notThrottleHandleChange(String(address), sessionToken)
    // }, 200);

  }, [localSearchIsActive, sessionToken, props.address]);

  const notThrottleHandleChange = React.useCallback((value) => {

    let centerrr = getCenterMap(mapRef, center)
    String(value).length > 0 && dispatch(Set_SearchAutoCompleteLoading(true));



    if (!localSearchIsActive) {
      String(value).length > 0 && dispatch(
        SearchAutoCompleteAction(dispatch, {
          query: value,
          latitude: centerrr.lat,
          longitude: centerrr.lng,
          sessionToken: sessionToken
        })
      );
    } else {
      String(value).length > 0 && dispatch(
        SearchAutoCompleteAction_local_address(dispatch, {
          query: value
        })
      );
    }

  }, [localSearchIsActive, sessionToken]);


  React.useEffect(() => {
    notThrottleHandleChange(String(props.address), sessionToken)
  }, [localSearchIsActive])



  React.useEffect(() => {
    if (deliveryLocationType != "address" && deliveryMethod?.id) {
      (async () => {
        setServicepointsIsLoading(true)
        const Services = new ServicesApi();
        const ServicePoints = await Services.ServicePoints({
          deliveryMethodId: deliveryMethod?.id,
          locationType: "dropoff"
        })
        console.log("ServicePoints5 ", ServicePoints)
        setServicepoints(ServicePoints)
        setServicepointsIsLoading(false)

      })();
    }
  }, [deliveryLocationType, deliveryMethod])


  const serachListData = React.useCallback(() => {

    if (deliveryLocationType != "address") {
      if (servicepoints && !_.isEmpty(servicepoints)) {
        return servicepoints
      } else {
        return null
      }
    }

    if (_.isEmpty(props.address)) {
      if (_.isEmpty(customerId)) {
        return null //error customer
      } else {
        if (_.isEmpty(recentAddress)) {
          return null //error recentAddress
        } else {
          return recentAddress
        }
      }
    } else {
      if (_.isEmpty(suggestPickUpDropOffListData)) {
        return null //error suggestPickUpDropOffListData
      } else {
        return suggestPickUpDropOffListData
      }
    }


  }, [recentAddress, customerId, props.address, suggestPickUpDropOffListData, deliveryLocationType, servicepoints]);


  const GetserachListItem = React.useCallback(() => {

    if (_.isEmpty(props.address) && deliveryLocationType == "address") {
      return RecentAddressItem
    } else {
      return AddressItem
    }


  }, [recentAddress, customerId, props.address, suggestPickUpDropOffListData, deliveryLocationType]);


  const GetserachListItemOnclickSP = React.useCallback((item) => {

    console.log("dwdwd dw ws dw ", item)

    dispatch(
      Set_latlng({ lng: item.coordinates.lng, lat: item.coordinates.lat })
    );
    dispatch(Set_DropOff_Inputs({
      name: "idx",
      value: item.id,
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))
    dispatch(Set_DropOff_Inputs({
      name: "name",
      value: item.name,
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))
    dispatch(Set_DropOff_Inputs({
      name: "address",
      value: item.address,
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))
    dispatch(Set_DropOff_Inputs({
      name: "adresss_loc",
      value: { lng: item.coordinates.lng, lat: item.coordinates.lat },
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))


    mapSetView({
      lng: item.coordinates.lng,
      lat: item.coordinates.lat,
    });

        setCollapsed(true)

  }, [first, id]);

  const GetserachListItemOnclick = React.useCallback(() => {

    if (_.isEmpty(props.address)) {
      return handleRecentList
    } else {
      return handleList
    }


  }, [recentAddress, customerId, props.address, suggestPickUpDropOffListData, deliveryLocationType]);



  const GetSearchListError = React.useCallback(() => {

    if (deliveryLocationType != "address") {
      if (_.isEmpty(props.address)) {
        if (!servicepoints || _.isEmpty(servicepoints)) {
          return {
            errorDescription: t("Add service points in admin center"),
            errorTitle: t("No service point available"),
            errorIcon: service_point,
            errorActionTitle: t("Add service point")
          }
        } else {
          return null
        }
      } else if (!_.isEmpty(props.address)) {
        if ((!servicepointsIsLoading && (servicepoints.length === 0 || _.isEmpty(servicepoints)))) {
          return {
            errorDescription: t("NoResultfromLocalDatabaseD"),
            errorIcon: null,
          }
        }
      }

    } else {

      //no recent address
      if (recentAddress.length == 0 && !_.isEmpty(customerId) && _.isEmpty(props.address)) {
        return {
          errorDescription: t("NoRecentAddressD"),
          errorTitle: t("NoRecentAddress"),
          errorIcon: HISTORY,
        }
      }

      //CustomerIsNotChoosed

      if (_.isEmpty(customerId) && _.isEmpty(props.address)) {
        return {
          errorDescription: t("CustomerIsNotChoosedD"),
          errorTitle: t("CustomerIsNotChoosed"),
          errorIcon: CUSTOMER_TYPE,
        }
      }



      if ((!suggestListPickUpDropOffLoading &&
        suggestPickUpDropOffListData.length === 0 && !_.isEmpty(props.address)) || (!_.isEmpty(props.address) && !suggestListPickUpDropOffLoading && !suggestPickUpDropOffListData)) {
        return {
          errorDescription: t("NoResultfromLocalDatabaseD"),
          errorTitle: t(localSearchIsActive ? "NoResultfromLocalDatabase" : "NoResultfromMapService"),
          errorIcon: null,
        }
      }

    }

  }, [recentAddress, customerId, props.address, servicepointsIsLoading, servicepoints, suggestPickUpDropOffListData, suggestListPickUpDropOffLoading, localSearchIsActive, deliveryMethod, deliveryLocationType]);

  const handleRecentList = React.useCallback((item) => {

    dispatch(
      Set_latlng({ lng: item.coordinates[0], lat: item.coordinates[1] })
    );

    dispatch(Set_DropOff_Inputs({
      name: "address",
      value: item.address,
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))
    dispatch(Set_DropOff_Inputs({
      name: "adresss_loc",
      value: { lng: item.coordinates[0], lat: item.coordinates[1] },
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))
    dispatch(Set_DropOff_Inputs({
      name: "block",
      value: item.buildingBlock,
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))
    dispatch(Set_DropOff_Inputs({
      name: "floor",
      value: item.floor,
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))

    dispatch(Set_DropOff_Inputs({
      name: "unit",
      value: item.room,
      firstDropOff: first,
      id: id == "dropoff" ? "dropoff" : id,
    }))
    mapSetView({
      lng: item.coordinates[0],
      lat: item.coordinates[1],
    });

    handleShowInfo()
    setCollapsed(true)

  }, [first, id]);

  const mapSetView = (e) => {
    setCenterMap(mapRef, e)
  };
  const handleList = React.useCallback((item) => {


    if (item.coordinates) {

      dispatch(
        Set_latlng({ lng: item.coordinates[0], lat: item.coordinates[1] })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "address",
          value: item.secondaryAddress
            ? item.address + " , " + item.secondaryAddress
            : item.address,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "adresss_loc",
          value: {
            lng: item.coordinates[0],
            lat: item.coordinates[1],
          },
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );


      mapSetView({
        lng: item.coordinates[0],
        lat: item.coordinates[1],
      });

      setSessionToken(null)

      handleShowInfo()
    setCollapsed(true)

    } else {

      let ss = sessionToken ? sessionToken : uuidv4()
      setSessionToken(ss)


      dispatch(
        PlaceIdDetailsAction(dispatch, { placeId: item.placeId, sessionToken: ss }, (res) => {

          setSessionToken(null)


          dispatch(
            Set_latlng({ lng: res.coordinates[0], lat: res.coordinates[1] })
          );

          dispatch(
            Set_DropOff_Inputs({
              name: "address",
              value: res.address,
              firstDropOff: first,
              id: id == "dropoff" ? "dropoff" : id,
            })
          );
          dispatch(
            Set_DropOff_Inputs({
              name: "adresss_loc",
              value: {
                lng: res.coordinates[0],
                lat: res.coordinates[1],
              },
              firstDropOff: first,
              id: id == "dropoff" ? "dropoff" : id,
            })
          );
          dispatch(
            Set_latlng({
              lng: res.coordinates[0],
              lat: res.coordinates[1],
            })
          );
        })
      );

      handleShowInfo()
    }
  }, [first, id]);

  const resetPickup = React.useCallback(() => {


    if (first && adresss_loc.lat != "" && dropOffCount > 1) {

      dispatch(
        Set_DropOff_Inputs({
          name: "address",
          value: items[1].address,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "adresss_loc",
          value: items[1].adresss_loc,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "placeId",
          value: items[1].placeId,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );



      dispatch(
        Set_DropOff_Inputs({
          name: "block",
          value: items[1].block,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "driver",
          value: items[1].driver,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "email",
          value: items[1].email,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "floor",
          value: items[1].floor,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "recieverFullName",
          value: items[1].recieverFullName,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "noteForDriver",
          value: items[1].noteForDriver,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "recieverPhoneNumber",
          value: items[1].recieverPhoneNumber,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "scheduleDateAfter",
          value: items[1].scheduleDateAfter,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );


      dispatch(
        Set_DropOff_Inputs({
          name: "scheduleDateBefore",
          value: items[1].scheduleDateBefore,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "unit",
          value: items[1].unit,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );


      dispatch(
        Set_DropOff_Inputs({
          name: "name",
          value: items[1].name,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "idx",
          value: items[1].id,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      handleCollapse({
        type: null,
        id: ""
      });

      removeDrop(items[1].id)
    } else {

      dispatch(
        Set_DropOff_Inputs({
          name: "address",
          value: "",
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "adresss_loc",
          value: { lng: "", lat: "" },
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "placeId",
          value: "",
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      dispatch(
        Set_DropOff_Inputs({
          name: "name",
          value: null,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );
      dispatch(
        Set_DropOff_Inputs({
          name: "idx",
          value: null,
          firstDropOff: first,
          id: id == "dropoff" ? "dropoff" : id,
        })
      );

      handleCollapse({
        type: null,
        id: ""
      });
    }


  }, [first, id, items, adresss_loc, dropOffCount]);



  const handleShowInfo = React.useCallback(() => {

    const isOpen = activePickupDropOff.id == id

    const myEvent = new CustomEvent("closeSliders", { detail: null });
    document.dispatchEvent(myEvent);


    if (!isOpen) {
      handleCollapse({
        type: "dropoff",
        id: id,
        firstDropOff: first
      });
    } else {
      setTimeout(() => {
        handleCollapse({
          type: null,
          id: ""
        });
      }, 100);
    }

  }, [first, id, activePickupDropOff]);




  const emailValidate = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }



  const vehicleRequiredCheck = React.useCallback(() => {

    if (orderTypeActive == "PickupDelivery") {


      let activeVehicleType = delivery_manual_id != "" && delivery_manual_id != null ? manual_activeVehicleType : auto_activeVehicleType;

      if (activeVehicleType) {
        if (activeVehicleType.options.length == 0) {
          return true
        } else {
          let isNotExist = false;
          let arrFiltered = activeVehicleType.options.filter((item) => item.isRequired);
          arrFiltered.forEach(element => {
            if (!VehicleOptionisSaved(element.id)) {
              isNotExist = true;
            }
          });
          return isNotExist == false
        }
      } else {
        return true
      }
    } else {
      return true
    }

  }, [props.driver, auto_activeVehicleType, manual_activeVehicleType, driveroptions, orderTypeActive]);


  const VehicleOptionisSaved = React.useCallback((id) => {
    console.log("VehicleOptionisSaved  ", id, driveroptions)

    let booll = false;
    booll = driveroptions.find((item) => {
      return item.id == id;
    });
    if (booll) {
      return true
    } else {
      return false
    }
  }, [driveroptions]);




  const handleOpenAddressbook = React.useCallback(() => {

    const myEvent = new CustomEvent("closeSliders", { detail: null });
    document.dispatchEvent(myEvent);

    setTimeout(() => {
      if (customerId || BusinessId) {
        if (openAddressBook && addressBookSource) {
          dispatch(SetopenAddressBookInNewOrder(false, "", null, ""));
        } else {
          dispatch(
            SetopenAddressBookInNewOrder(
              true,
              "dropoff",
              id,
              "AddressbookDropOf"
            )
          );
        }
      }
    },
      100);
  }, [customerId, BusinessId, openAddressBook, addressBookSource, id]);


  // const handleChangeLocalSearch = React.useCallback((value) => {


  // }, []);


  React.useEffect(() => {

    if (!auto_activeVehicleType && auto_suggestListData.length > 0) {
      dispatch(Set_Auto_ActiveVehicleTypeـPickupDeliveryType_Dropoff(auto_suggestListData[0]))
    }

  }, [auto_activeVehicleType, auto_suggestListData])


  const detectOrderType = React.useCallback(() => {

    if (activeVehicleType?.orderTypes?.indexOf("PickupDelivery") > -1) {
      return "PickupDelivery"
    } else {
      return "Ondemand"
    }

  }, [activeVehicleType])

  React.useEffect(() => {

    try {
      document.addEventListener('closeSliders', () => {
        //

        handleCollapse({
          type: null,
          id: ""
        });

        //
      })


      return () => {
        document.removeEventListener("closeSliders", () => {

        });
      };

    } catch (error) {

    }
  }, [])

  // React.useEffect(() => {

  //   if(deliveryLocationType != "address" && isEmpty(props.name) && isEmpty(props.idx) && !isEmpty(String(adresss_loc.lat))){
  //     dispatch(
  //       Set_DropOff_Inputs({
  //         name: "address",
  //         value: "",
  //         firstDropOff: first,
  //         id: id == "dropoff" ? "dropoff" : id,
  //       })
  //     );
  //     dispatch(
  //       Set_DropOff_Inputs({
  //         name: "adresss_loc",
  //         value: { lng: "", lat: "" },
  //         firstDropOff: first,
  //         id: id == "dropoff" ? "dropoff" : id,
  //       })
  //     );
  //     dispatch(
  //       SetCanSaveTravel({ canSaveOrder: false, loading: false })
  //     );
  //              dispatch(SetPriceNewOrder({ done: false }, { done: false ,where:"747" }));

  //   }


  //   if(deliveryLocationType == "address" && !isEmpty(props.name) && !isEmpty(props.idx) && !isEmpty(String(adresss_loc.lat))){
  //     dispatch(
  //       Set_DropOff_Inputs({
  //         name: "address",
  //         value: "",
  //         firstDropOff: first,
  //         id: id == "dropoff" ? "dropoff" : id,
  //       })
  //     );
  //     dispatch(
  //       Set_DropOff_Inputs({
  //         name: "idx",
  //         value: null,
  //         firstDropOff: first,
  //         id: id == "dropoff" ? "dropoff" : id,
  //       })
  //     );
  //     dispatch(
  //       Set_DropOff_Inputs({
  //         name: "name",
  //         value: null,
  //         firstDropOff: first,
  //         id: id == "dropoff" ? "dropoff" : id,
  //       })
  //     );
  //     dispatch(
  //       Set_DropOff_Inputs({
  //         name: "adresss_loc",
  //         value: { lng: "", lat: "" },
  //         firstDropOff: first,
  //         id: id == "dropoff" ? "dropoff" : id,
  //       })
  //     );

  //     dispatch(
  //       SetCanSaveTravel({ canSaveOrder: false, loading: false })
  //     );
  //              dispatch(SetPriceNewOrder({ done: false }, { done: false ,where:"747" }));


  //   }

  //  }, [deliveryLocationType , props.name , props.idx])

  if (isEmpty(String(adresss_loc.lat))) {
    return <div className={clsx(styles.PickupOnlyNewOrderContainer, ["Ondemand", "PickupDelivery"].indexOf(
      orderTypeActive
    ) > -1 && styles.PickupDelivery)}  style={{height:"auto"}}>
      {/* {["Ondemand"].indexOf(
        orderTypeActive
      ) > -1 && (
          <hr className={styles.hr} />
        )} */}

      <div className={styles.PickupOnlyNewOrderContainerFirstRow}>
                  {dropOffCount > 1 && <IconProvider Icon={DRAG} size='16' style={{ cursor: "pointer", marginInlineEnd: "0px" }} />}
          {(orderTypeActive == "Ondemand" && dropOffCount > 1) ? <span className={styles.dropNumber} style={{ marginInlineEnd: "2px" }}>{index + 1}</span> : <IconProvider Icon={pickup_new} size='16' style={{transform:"rotate(180deg)"}} />}      
          
 
        {dropOffCount == 0 && <IconProvider Icon={pickup_new} size='16' style={{transform:"rotate(180deg)"}} />}
        <Typography text={t("Deliver to")} weight='Body_Middle_Bold'   style={{fontSize:"13px" , fontWeight:"600"}} />
        {props.address.length == 0 && <span className={styles.starRequired} style={{marginInlineStart:"3px"}}>*</span>}

       {(orderTypeActive == "Ondemand" && !first && dropOffCount > 1) && <img src={trash} style={{width:"14px" , cursor:"pointer"}} onClick={()=>{removeDrop(id)}} />}
        {ActivescheduleSetting &&
          <Schedule orderType={detectOrderType()}
            scheduleDateBefore={props.scheduleDateBefore}
            scheduleDateAfter={props.scheduleDateAfter}
            type={"delivery"}
            firstDropOff={first}
            id={id}
          />}
      </div>

      <div className={styles.PickupOnlyNewOrderContainerSecondRow}>
        <SearchList DefaultListPreview={(isEmpty(props.address) && deliveryLocationType != "address" && servicepoints && servicepoints.length > 0) && <div className={styles.DefaultListPreview}>
          <Typography weight='Body_Tiny_Medium' text={t("All Service points")} style={{ marginTop: "16px", marginBottom: "4px", width: "100%", width: "calc(100% - 24px)", marginInlineStart: "12px", marginInlineEnd: "12px", marginTop: "8px", color: "#484848" }} />
          <div className={styles.DefaultListItemsContainerPreview}>
            {servicepoints.map((item) => {
              return <ServicePoint_addressItem data={item} onclick={() => { GetserachListItemOnclickSP(item) }} />
            })}
          </div>

        </div>} errorActionOnClick={() => {
          window.location.replace("/admin/service-points/create")
        }} inputIcon={!(isLocalAddressActive && deliveryLocationType == "address") && <img src={deliveryLocationType == "address" ? newsearch : service_point} />}
          onChange={deliveryLocationType == "address" ? (e) => handlePickUpInputs(e, "address") : (e) => handleSearchSPInput(e, "address")} style={{ zIndex: "1" }} value={props.address} placeHolder={deliveryLocationType == "address" ? t("Search and select address") : t("Search and select service point")}
          isloading={deliveryLocationType == "address" ? suggestListPickUpDropOffLoading : servicepointsIsLoading}
          listItemOnclick={deliveryLocationType == "address" ? GetserachListItemOnclick() : GetserachListItemOnclickSP}
          error={GetSearchListError()}
          errorDescription={GetSearchListError()?.errorDescription}
          errorTitle={GetSearchListError()?.errorTitle}
          inputInnerChildrenposition="Left"
          errorIcon={GetSearchListError()?.errorIcon}
          errorActionTitle={GetSearchListError()?.errorActionTitle}
          SearchListInput={{paddingInlineStart:"8px" , width : 'calc(100% - 27px)'}}
          ListItemChildren={deliveryLocationType == "address" ? GetserachListItem() : ServicePoint_addressItem}
          list={serachListData()}
          inputInnerChildren={deliveryLocationType == "address" ? (isLocalAddressActive ? (
          <DropDown style={{backgroundColor:"unset !important" , height:"24px" ,padding:"0px"}} size='Small' placement='bottomEnd' selectedvalue={localSearchIsActive ? t("Local") : t("Map")} 
          text={localSearchIsActive ?  <img src={database} style={{width:"14px"}} /> : <img src={map}  style={{width:"14px"}}/>}
            data={[t("Map"), t("Local")]} onClick={handleChangeLocalSearch} />) : null) : null}
          
        />
        {deliveryLocationType == "address" && <Button icon={LOCATION} size='Medium' type='Secondary'  style={{ backgroundColor:"transparent", padding :"7px 6px" , marginInlineStart :"-6px"}}  onClick={handleShowInfo} isActive={activePickupDropOff.id == id} />}
        {deliveryLocationType == "address" && <Button icon={ADDRESS_BOOK} size='Medium'  style={{ backgroundColor:"transparent", padding :"7px 6px"}}  type='Secondary' disabled={((customerId && String(customerId).length > 0) || (BusinessId && String(BusinessId).length > 0)) ? false : true} onClick={handleOpenAddressbook} isActive={addressBookSource} />}
        {/* {(orderTypeActive == "Ondemand" && !first && dropOffCount > 1) && <Button size={'Small'} icon={CLOSE_DARK} type='Secondary' style={{ marginInlineStart: "4px", backgroundColor: "transparent", padding: "8px 8px" }} onClick={() => (orderTypeActive == "Ondemand" && !first && dropOffCount > 1) ? removeDrop(id) : resetPickup()} />} */}
          <Button className={!collapsed && styles.arrowDown} icon={double_top} size={'Medium'} type='Secondary' requiredText='*' isRequired={showRequirdalert()} onClick={() => { setCollapsed(!collapsed) }} style={{ paddingInlineStart: "auto", paddingInlineEnd: "auto", padding: "7px", width: "14px", height: "14px" }} />

      </div>

              <DeliveryInfoNewOrder {...props} id={id} first={first} handleShowInfo={handleShowInfo} pickupRequiredCheck={pickupRequiredCheck()}  collapsed={collapsed} setCollapsed={setCollapsed}   />

    </div>
  }

  return (
    <>

      <div className={clsx(styles.PickupOnlyNewOrderSelectedContainer, ["Ondemand", "PickupDelivery"].indexOf(
        orderTypeActive
      ) > -1 && styles.PickupDelivery)}>
        {/* {["Ondemand"].indexOf(
          orderTypeActive
        ) > -1 && (
            <hr className={styles.hr2} />
          )} */}


        <div className={styles.PickupOnlyNewOrderContainerFirstRow}>
          {dropOffCount > 1 && <IconProvider Icon={DRAG} size='16' style={{ cursor: "pointer", marginInlineEnd: "0px" }} />}
 
          {(orderTypeActive == "Ondemand" && dropOffCount > 1) ? <span className={styles.dropNumber} style={{ marginInlineEnd: "2px" }}>{index + 1}</span> : <IconProvider Icon={pickup_new} size='16' style={{transform:"rotate(180deg)"}} />}        <Typography text={t("Deliver to")} weight='Body_Middle_Bold'   style={{fontSize:"13px" , fontWeight:"600"}} />
          {props.address.length == 0 && <span className={styles.starRequired}>*</span>}
          {ActivescheduleSetting &&
            <Schedule orderType={detectOrderType()}
              scheduleDateBefore={props.scheduleDateBefore}
              scheduleDateAfter={props.scheduleDateAfter}
              type={"delivery"}
              firstDropOff={first}
              id={id}
            />}
        </div>

        <div className={styles.PickupOnlyNewOrderSelectedContainerFrow} style={{ marginTop: (props.name && props.name.length > 0) && "4px" }}>
          {(props.name && props.name.length > 0) && <img src={service_point} />}
          <div style={{ display: "flex", flexDirection: "column", gap: "0px", flex: "1" }}>
            {(props.name && props.name.length > 0) && <Typography text={props.name} weight='Body_Middle_Regular' style={{
              width: "275px", overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px"
            }} />}
            <Typography text={props.address} weight={(props.name && props.name.length > 0) ? "Body_Tiny_Regular" : 'Body_Middle_Regular'} style={{
              width: "275px", overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px", color: (props.name && props.name.length > 0) ? "rgba(128, 128, 128, 1)" : 'rgba(72, 72, 72, 1)'
            }} />
          </div>

          <Button size={'Small'} icon={CLOSE_DARK} type='Secondary' style={{ marginInlineStart: "4px", backgroundColor: "transparent", padding: "7px" }} onClick={() => (orderTypeActive == "Ondemand" && !first && dropOffCount > 1) ? removeDrop(id) : resetPickup()} />
          <Button className={!collapsed && styles.arrowDown} icon={double_top} size={'Medium'} type='Secondary' requiredText='*' isRequired={showRequirdalert()} onClick={() => { setCollapsed(!collapsed) }} style={{ paddingInlineStart: "auto", paddingInlineEnd: "auto", padding: "7px", width: "14px", height: "14px" }} />

        </div>


        {/* {( !pickupRequiredCheck()) && <Typography text={t("CompleteRequiredFeileds")} weight='Body_Small_Regular' style={{
          width: "345px", overflow: 'hidden',
          textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1"
        }} textColor='Red' />}  */}
        <DeliveryInfoNewOrder {...props} id={id} first={first} handleShowInfo={handleShowInfo} pickupRequiredCheck={pickupRequiredCheck()}  collapsed={collapsed} setCollapsed={setCollapsed}   />

      </div>

    </>

  )
}

export default DeliveryNewOrder